import { createContext, useContext, useState } from "react";
import { STR } from "@/lib/i18n";

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("demoivre_lang") || "fr");
  const setLang = (l) => {
    setLangState(l);
    localStorage.setItem("demoivre_lang", l);
  };
  const t = (key) => key.split(".").reduce((o, k) => (o == null ? o : o[k]), STR[lang]) ?? key;
  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
